import React from "react";
import Paginator from "./paginator.jsx";
import {Checkbox} from "react-bootstrap";
import TimecardListItem from "./timecard-list-item.jsx";

export default class TimecardList extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        
        let items = []

        let vm = this.props.vm; // Expected to be an array of listItem       
        if (vm == null || vm.timecards == null || vm.timecards == 0) {
            return(
                <div className="ap-fullsize ap-grid-result text-center">
                    No Timecard Found!
                </div>
                );
        } else {
            for(let i=0; i<vm.timecards.length; i++) {
                let dataItem = vm.timecards[i];
                items.push(
                    <TimecardListItem vm={dataItem} key={dataItem.timecardSummary.timecardId} role={this.props.role} onChecked={this.props.onTcItemChecked}/>
                    );              
            }

        return(
                <div className="ap-timecard-list-container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="container-fluid ap-timecard-list-header">
                                <div className="row">
                                    <div className="col-xs-12 col-sm-12 col-md-1 col-lg-1">
                                        <Checkbox className="ap-header-checkbox" checked={vm.isAllSelected === true}
                                                  onChange={() => this.props.onTcItemChecked("all")}/>
                                    </div>
                                    <div className="hidden-xs hidden-sm col-md-2 col-lg-2 ap-col-title">
                                        Name
                                    </div>
                                    <div className="hidden-xs hidden-sm col-md-2 col-lg-2 ap-col-title">
                                        Report To
                                    </div>
                                    <div className="hidden-xs hidden-sm col-md-1 col-lg-1 ap-col-title">
                                        Assign ID
                                    </div>
                                    <div className="hidden-xs hidden-sm col-md-1 col-lg-1 ap-col-title">
                                        Week Ending
                                    </div>
                                    <div className="hidden-xs hidden-sm col-md-1 col-lg-1 ap-col-title">
                                        Regular Time
                                    </div>
                                    <div className="hidden-xs hidden-sm col-md-1 col-lg-1 ap-col-title">
                                        Over Time
                                    </div>
                                    <div className="hidden-xs hidden-sm col-md-1 col-lg-1 ap-col-title">
                                        Double Time
                                    </div>
                                    <div className="hidden-xs hidden-sm col-md-1 col-lg-1 ap-col-title">
                                        Misc Time
                                    </div>
                                    <div className="hidden-xs hidden-sm col-md-1 col-lg-1 ap-col-title">
                                        Total
                                    </div>
                                </div> 
                            </div>
                        </div>
                    </div>
                    <div className="row">                        
                        <div className="col-lg-12">                            
                            <div className="container-fluid ap-timecard-list">
                                {items}
                            </div>
                        </div>
                    </div>                
                    <div className="row">   
                            <div className="col-lg-12">
                                <Paginator total={this.props.totalPage} range="3" selectedIndex={this.props.page} 
                                onNavigate={this.props.onNavigate} />            
                            </div>
                    </div>
                </div>
                );
        }
    }
}